module.exports = __webpack_public_path__ + "img/ser12.d7136df9.png";